module.exports = __webpack_public_path__ + "static/media/tank-fill.0a5dc3a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tank-fill.png
// module id = 1137
// module chunks = 0